import { ReferralSourceModel } from './referralSourceModel';

export class AddReferralSourceModel extends ReferralSourceModel {
}
